import Joi from "joi";

import {constantsRegex} from "../constants/constants.regex";

export const forgotPasswordStep1Validator = Joi.object({
    email: Joi.string().pattern(constantsRegex.EMAIL).required().messages({
        'string.empty': 'Заповніть це поле',
        'string.pattern.base': 'Невалідний email',
    }),
})
